import * as actions from '../actions';

const authInterceptor = ({ dispatch }) => (next) => (action) => {
  if (action.err && action.err.response) {
    if ( action.err.response.status === 401 ) {
      dispatch( actions.logout() );
    }
  } else {
    next(action);
  }
};

export default authInterceptor;
